import { useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserProfile } from '../../contexts/UserProfileContext';
import { ATLAS_LENS_SPACING_EXPR } from '../Form/atlasLensTokens';

export function LegacySamplePreviewGuard({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { appAccountType, isLoading } = useUserProfile();

  useEffect(() => {
    if (!isLoading && appAccountType && appAccountType !== 'legacy') {
      navigate('/courses', { replace: true });
    }
  }, [appAccountType, isLoading, navigate]);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={ATLAS_LENS_SPACING_EXPR.loadingPlaceholderMinHeight}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (appAccountType !== 'legacy') {
    return null;
  }

  return children;
}
